import { Arr, Num, Obj } from "@kizmann/pico-js";
import NTableCellOption from "@kizmann/nano-ui/src/table/src/table-cell/types/table-cell-option.jsx";

export default Obj.assign({}, NTableCellOption, {

    name: 'NTableCellClient',

    render()
    {
        if ( ! this.init ) {
            return null;
        }

        let item = Arr.find(this.$root.tokens, {
            id: this.input
        });

        return (
            <div>
                <span>{item ? item.client : this.trans('No client')}</span>
            </div>
        );
    }

});